import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminsales',
  templateUrl: './adminsales.component.html',
  styleUrls: ['./adminsales.component.css']
})
export class AdminsalesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
